import React, { useState } from "react";
import { Link } from "react-router-dom";
import gainend from "main/assets/images/Images/Platform - Images/gain-end.png";
import objective1 from "main/assets/images/Images/Platform - Images/objective_1.png";
import objective2 from "main/assets/images/Images/Platform - Images/objective_2.png";
import objective3 from "main/assets/images/Images/Platform - Images/objective_3.png";
import objective4 from "main/assets/images/Images/Platform - Images/objective_4.png";
import objective5 from "main/assets/images/Images/Platform - Images/objective_5.png";
import objective6 from "main/assets/images/Images/Platform - Images/objective_6.png";
import performfield from "main/assets/images/Images/Platform - Images/perform-field.png";
import datadriven from "main/assets/images/Images/Platform - Images/data-driven.png";
import intelligentoperation from "main/assets/images/Images/Platform - Images/intelligent-operation.png";
import enableearly from "main/assets/images/Images/Platform - Images/enable-early.png";
import downstream from "main/assets/images/Images/Platform - Images/downstream.png";
import improvetechnician from "main/assets/images/Images/Platform - Images/improve-technician.png";
import digitalfield from "main/assets/images/Images/Platform - Images/digital-field.png";
import capacityplanningimg from "main/assets/images/Images/Platform - Images/capacity-planning-Graf.svg";
import strategicplanningimg from "main/assets/images/Images/Platform - Images/platorm_stategic_graph.svg";
import getintouchbg from "main/assets/images/Images/Platform - Images/getintouchbg.png";
import platformgit from "main/assets/images/Images/Platform - Images/platform_git.png";
import operationalplanningimg from "main/assets/images/Images/Platform - Images/platform_operational_graph.svg";
import routemappingimg from "main/assets/images/Images/Platform - Images/platform_routeplanning_graph.svg";
import scenariomodelimg from "main/assets/images/Images/Platform - Images/scenario-modelling-graf.png";
import jeopardmanagement from "main/assets/images/Images/Platform - Images/platform_jeopad_graph.svg";
import GraphDataOnLeft from "main/components/componentsHelper/platformspage/GraphDataOnLeft";
import GraphDataOnRight from "main/components/componentsHelper/platformspage/GraphDataOnRight";
import digitaltwin from "main/assets/images/Images/Platform - Images/digitaltwin.png";
import imageall from "main/assets/images/Images/Platform - Images/imageall.png";
import { Button } from "main/components/ui-components/Button";
import PlatformSlider from "./PlatformSlider";

// Swiper Package

type Props = {};

const Platform = (props: Props) => {
  // const ecosystemleft: string[] = [
  //   "Gain End-to-end visibility of supply and demand",
  //   "Perform Field service Automation with Yantr.ai",
  //   "AI for data driven decisions",
  //   "Intelligent operations that is flexible and sustainable",
  // ];
  // const ecosystemright: string[] = [
  //   "A digital twin for existing controltower",
  //   "Perform Field service Automation with Yantr.ai",
  //   "AI for data driven decisions",
  //   "Intelligent operations that is flexible and sustainable",
  // ];
  const benefits = [
    {
      index: 1,
      title: "Gain end-to-end visibility of supply and demand",
      desc: "Establish complete oversight of resource flows from inception to consumption.",
      image: gainend,
      mobileImage: objective1,
    },
    {
      index: 2,
      title: "Perform field service automation",
      desc: "Automate routine tasks and processes to enhance operational efficiency and reduce human error.",
      image: performfield,
      mobileImage: objective2,
    },
    {
      index: 3,
      title: "Achieve Data-driven decisions",
      desc: "Leverage analytical tools to base critical operational decisions on empirical data insights.",
      image: datadriven,
      mobileImage: objective3,
    },
    {
      index: 4,
      title: "Achieve intelligent operations that are flexible and sustainable",
      desc: "Implement smart systems that adapt to changing conditions while minimizing environmental impact.",
      image: intelligentoperation,
      mobileImage: objective4,
    },
    {
      index: 5,
      title: "Enable early alert mechanisms",
      desc: "Set up proactive alerts to anticipate and address issues before they escalate.",
      image: enableearly,
      mobileImage: objective5,
    },
    {
      index: 6,
      title: "Simulate decisions with downstream impact quantification",
      desc: "Use predictive models to forecast the effects of potential decisions across the operation chain.",
      image: downstream,
      mobileImage: objective6,
    },
    {
      index: 7,
      title: "Improve Technician efficiency",
      desc: "Empower operations to achieve unparalleled technical efficiency, optimizing resource allocation , reducing operational costs and enhancing productivity through AI driven insights and automation.",
      image: improvetechnician,
      mobileImage: objective6,
    },
    {
      index: 8,
      title: "Reimagined and Digital field workforce",
      desc: "Ensure a fully digital and optimized field workforce, enhancing productivity and enabling seamless real-time management for a more agile and efficient field service operation.",
      image: digitalfield,
      mobileImage: objective6,
    },
  ];

  const [row, setRow] = useState<any>(1);
  const [img, setImg] = useState<any>(gainend);
  const [mobileImg, setMobileImg] = useState<any>(objective1);

  const SelectRow = (index: any, image: any) => {
    setRow(index);
    setImg(image);
    setMobileImg(image);
  };

  return (
    <div>
      <PlatformSlider />

      {/*       <img
          className="wp-100 px-40 py-20 m-1 padd"
          src={yatraAiofferings}
          alt="yantr ai offerings"
        /> */}
      {/* mobile */}
      <div className="d-block d-md-none pb-40 footer">
        <div className=" d-flex flex-column line-35 justify-content-center align-items-center">
          <div className="text-white-color font-30 py-20 align-items-center justify-content-center fonts-800 line-35 font-family-roboto garph-heading">
            Explore Modules
          </div>
          <div className="d-flex px-53 text-white-color pb-30 font-20 line-23 font-family-roboto fonts-500 text-center graph-subhead2">
            Yantr.ai is modular with capabilities to address different aspects
            of the supply chain and field operations.
          </div>
        </div>
        {/* Website */}
        <div className="d-none d-md-block">
          <div className="py-35 d-flex flex-column line-35 justify-content-center align-items-center">
            <div className="text-white-color font-30 pb-10 align-items-center justify-content-center fonts-800 line-35 font-family-roboto garph-heading">
              Explore Modules
            </div>
            <div className="d-flex px-30 text-white-color pt-15 pb-10 font-20 line-23 font-family-roboto fonts-500 text-center graph-subhead2">
              Yantr.ai is modular with capabilities to address different aspects
              of the supply chain and field operations.
            </div>
          </div>
        </div>
        <div className="d-flex flex-column flex-gap-20 py-0">
          <GraphDataOnLeft
            path={capacityplanningimg}
            paragraphClass="text-color-success"
            headingClass="text-color-success"
            heading="Capacity Planning (Forecasting)"
            paragraph="Utilize ML-driven forecasting algorithms in Yantr.ai to predict demand (work volume) and supply (number of technicians needed) based on historical data. Incorporate external data sources, like weather, for enhanced accuracy."
            explore={"Explore"}
            to={"/capacity-planning"}
          />
          <GraphDataOnRight
            path={strategicplanningimg}
            headingClass="text-color-success"
            paragraphClass="text-color-success"
            heading="Strategic Planning"
            paragraph="Improve Strategic planning with AI insights for technicians and work orders. Get proactive updates on work order changes, team upskilling, and technician relocations for business needs."
            explore={"Explore"}
            to={"/strategic-planning"}
          />
          <GraphDataOnLeft
            path={operationalplanningimg}
            paragraphClass="text-color-success"
            headingClass="text-color-success"
            heading="Operational Planning"
            paragraph="Optimize and align daily demand and supply using our top-tier industry optimization package. Monitor key metrics and receive recommendations for enhanced planning."
            explore={"Explore"}
            to={"/operational-planning"}
          />
          <GraphDataOnRight
            path={jeopardmanagement}
            headingClass="text-color-success"
            paragraphClass="text-color-success"
            heading="Jeopardy Management"
            explore={"Explore"}
            paragraph="Optimize your Jeopardy, Triage, and Unscheduled Work orders by strategically allocating your workforce across various locations, based on the priority and urgency of tickets, ensuring adherence to Service Level Agreements (SLAs)."
            to={"/jeopardy-management"}
          />
          <GraphDataOnLeft
            path={routemappingimg}
            paragraphClass="text-color-success"
            headingClass="text-color-success"
            heading="Route Planning"
            explore={"Explore"}
            to={"/route-mapping"}
            paragraph="Plan optimal routes with accurate ETAs for deliveries and supply chain logistics use cases for each vehicles. Manage vehicle capacity to meet planned and unplanned demand."
          />
          <GraphDataOnRight
            path={scenariomodelimg}
            headingClass="text-color-success"
            paragraphClass="text-color-success"
            heading="Scenario Modelling"
            explore={"Explore"}
            to={"/scenario-modelling"}
            paragraph='Explore the "what-ifs" of field service operations using advanced simulations. Empower planners to anticipate desired outcomes, compare them to baseline scenarios, and make more informed decisions.'
          />
        </div>
      </div>
      <section className="container py-35 mb-20 d-flex font-family-roboto align-items-center ">
        <div>
          {/*Mobile View */}
          <div className="d-block d-md-none">
            <p className="reset dark-header fonts-800 font-30 mb-30 line-35 text-align-center plat-header d-block d-md-none">
              Yantr.ai Platform Objectives
            </p>
            <fieldset className="platform-border p-0 reset">
              <div className="w-100 justify-content-between p-10">
                <div className="col-md-4 p-15">
                  {benefits.slice(0, 6).map((item: any, index: any) => {
                    return (
                      <div
                        onClick={() => SelectRow(index + 1, item.mobileImage)}
                        key={index}
                        className={`d-flex justify-content-start gap-4 flex-row align-items-start position-relative cursor`}
                      >
                        <span
                          className={`col-4 wx-20 hx-20 rounded-circle border-color d-flex mt-1 z-index-100 ${
                            row === index + 1 ? "platform-bg-color" : "bg-white"
                          }`}
                        ></span>
                        {index < benefits.length - 3 && (
                          <span
                            className={`position-absolute verticle_line`}
                          ></span>
                        )}
                        <p
                          className={`${
                            row === index + 1
                              ? "col-11 platform-text-color fonts-600 line-21 font-18"
                              : "col-11 dark-header fonts-600 line-21 font-18"
                          } font-16 min-h-60 aboutus-subcontent`}
                        >
                          {item?.title}
                        </p>
                      </div>
                    );
                  })}
                </div>

                <div
                  style={{
                    backgroundImage: "url(" + mobileImg + ")",
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    height: "250px",
                  }}
                  className="col-md-12 col-sm-12 col-lg-8 justify-content-end align-items-center justify-content-center radius-26 overflow-hidden"
                >
                  <div className="row vh-57">
                    <div
                      style={{
                        background: `linear-gradient(to bottom, rgba(255, 255, 255, 0.01), rgba(0, 0, 0, 01))`,
                        height: "250px",
                      }}
                      className="py-md-5 col-lg-12 d-flex justify-content-between flex-row align-items-end"
                    >
                      {benefits.map(
                        (val, index) =>
                          row === index + 1 && (
                            <div key={index} className="align-items-center p-1">
                              <p className="d-flex text-white-color font-family-roboto fonts-500 font-21 line-18 pb-10">
                                {row === index + 1 ? val?.title : ""}
                              </p>
                              <h6 className="d-flex text-white-color font-family-roboto fonts-400 font-14 line-16 mb-20">
                                {" "}
                                {row === index + 1 ? val?.desc : ""}
                              </h6>
                            </div>
                          )
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </fieldset>
          </div>
          {/* Website View */}
          <div className="d-none d-md-block">
            <fieldset className="platform-border p-25 reset d-none d-md-block">
              <legend className="reset dark-header fonts-800 font-30 mb-30 line-35 text-align-center plat-header d-none d-md-block">
                Yantr.ai Platform Objectives
              </legend>

              <div className="row w-100 justify-content-between p-10">
                <div className="col-md-4">
                  {benefits.map((item: any, index: any) => {
                    return (
                      <div
                        onClick={() => SelectRow(index + 1, item.image)}
                        key={index}
                        className={`d-flex justify-content-start gap-3 flex-row align-items-start position-relative cursor`}
                      >
                        <span
                          className={`col-4 wx-20 hx-20 rounded-circle border-color d-flex mt-1 z-index-100 ${
                            row === index + 1 ? "platform-bg-color" : "bg-white"
                          }`}
                        ></span>
                        {index < benefits.length - 1 && (
                          <span
                            className={`position-absolute verticle_line`}
                          ></span>
                        )}
                        <p
                          className={`${
                            row === index + 1
                              ? "col-11 platform-text-color fonts-600 line-21 font-18"
                              : "col-11 dark-header fonts-600 line-21 font-18"
                          } font-16 min-h-60 aboutus-subcontent`}
                        >
                          {item?.title}
                        </p>
                      </div>
                    );
                  })}
                </div>
                <div
                  style={{
                    backgroundImage: "url(" + img + ")",
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "cover",
                    //backgroundPosition: "center",
                  }}
                  className="col-md-12 col-sm-12 col-lg-8 justify-content-end align-items-center justify-content-center radius-26 overflow-hidden"
                >
                  <div className="row h-100">
                    <div
                      style={{
                        background: `linear-gradient(to bottom, rgba(255, 255, 255, 0.01), rgba(0, 0, 0, 01))`,
                      }}
                      className="py-md-5 col-lg-12 h-100 d-flex justify-content-between flex-row align-items-end"
                    >
                      {benefits.map(
                        (val, index) =>
                          row === index + 1 && (
                            <div key={index} className="align-items-center">
                              <p className="d-flex text-white-color font-family-roboto fonts-500 font-24 line-28 pb-20 head18">
                                {row === index + 1 ? val?.title : ""}
                              </p>
                              <h6 className="d-flex text-white-color font-family-roboto fonts-400 font-16 line-18 mb-20 aboutus-subcontent">
                                {" "}
                                {row === index + 1 ? val?.desc : ""}
                              </h6>
                            </div>
                          )
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </fieldset>
          </div>
        </div>
      </section>
      <div className="pb-10 footer">
        <div className="d-flex flex-column line-35 py-35 justify-content-center align-items-center">
          <div className="text-white-color font-30 fonts-800 line-35 font-family-roboto mb-20 text-center plat-header-p">
            A Digital Twin for Existing Control Tower
          </div>
          <img
            className="wp-70 pb-20"
            src={digitaltwin}
            alt="yantr ai offerings"
          />
          <img
            className="wp-60 pb-40"
            src={imageall}
            alt="yantr ai offerings"
          />
          <div className="px-20 text-white-color font-16 line-18 font-family-roboto fonts-400 text-center text-align-center footer-subcontent2">
            Yantr.ai minimizes unproductive practices in field service
            management and saves admin teams time and energy.
          </div>
          <div className="px-20 text-white-color font-16 line-18 font-family-roboto fonts-400 text-center text-align-center footer-subcontent2">
            Thus, employees can focus on more value-enabling responsibilities
            and achieve better savings.
          </div>
        </div>
      </div>
      <div className="d-block d-md-none">
        {" "}
        {/* mobile */}
        <div className="mt-40">
          <div className="container">
            <section
              className="mb-40 py-5 py-md-5 radius-20 position-relative"
              style={{
                backgroundImage: `url(${platformgit})`,
                backgroundRepeat: "no-repeat",
                backgroundSize: "100% 100%",
                height: "350px",
              }}
            >
              <div className="row py-0 py-md-5 mb-100">
                <div className="col-lg-6 col-md-12"></div>
                <div className="col-lg-6 col-md-12 top-15 paddingL">
                  <p className="text-white-color fonts-800 font-family-roboto font-30 line-35 pt-25 mb-15 footer-content ">
                    Get in Touch With Us
                  </p>
                  <p className="text-white-color fonts-400 font-family-roboto font-22 line-25 mb-30 line15">
                    Start your Field Service Transformation Yantr.ai
                  </p>
                  <div className="d-block d-md-none">
                    {" "}
                    {/* mobile */}
                    <Link to={"/contact-us"}>
                      <Button
                        className="py-6 px-20 font-16 fonts-500 text-white-color"
                        onClick={() => {}}
                      >
                        Explore
                      </Button>
                    </Link>
                  </div>
                </div>
              </div>
              <div className="container p-0 position-absolute bottom-0">
                <div className="h-100 d-flex justify-content-between flex-row align-items-end">
                  <div className="w-100 d-block d-md-none">
                    <div
                      className="justify-content-between wp-100 paddingLtb"
                      style={{
                        backgroundColor: "#230457",
                        opacity: "70%",
                        borderRadius: "0px 0px 25px 25px",
                      }}
                    >
                      <div className="text-white-color font-family-roboto line-35 text-start font-30 fonts-800 garph-heading pb-10">
                        Not Convinced ?
                      </div>
                      <Link to="/why-yantr-ai">
                        <Button
                          className="py-6 px-20 font-16 fonts-500 text-white-color"
                          text="Why Yantr.ai"
                        />
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
      <div className="d-none d-md-block">
        {" "}
        {/* website */}
        <div className="mx-30 py-50">
          <div className="container">
            <section
              className="py-3 py-md-5 radius-20 position-relative"
              style={{
                backgroundImage: `url(${getintouchbg})`,
                backgroundRepeat: "no-repeat",
                backgroundSize: "100% 100%",
              }}
            >
              <div className="row py-0 py-md-5 mb-100">
                <div className="col-lg-6 col-md-12"></div>
                <div className="col-lg-6 col-md-12 top-15 paddingL">
                  <p className="text-white-color fonts-800 font-family-roboto font-30 line-35 mb-15 footer-content ">
                    Get in Touch With Us
                  </p>
                  <p className="text-white-color fonts-400 font-family-roboto font-22 line-25 mb-30 line15">
                    Start your Field Service Transformation Yantr.ai
                  </p>
                  <div className="d-none d-md-block">
                    {" "}
                    {/*website */}
                    <Link to={"/contact-us"}>
                      <Button
                        className="py-12 px-40 font-16 fonts-500 text-white-color"
                        onClick={() => {}}
                      >
                        Explore
                      </Button>
                    </Link>
                  </div>
                </div>
              </div>
              <div className="container p-0 position-absolute bottom-0">
                <div className="h-100 d-flex justify-content-between flex-row align-items-end">
                  <div className="w-100 d-none d-md-block">
                    <div
                      className="d-flex justify-content-between wp-100 p-4"
                      style={{
                        backgroundColor: "#230457",
                        opacity: "70%",
                        borderRadius: "0px 0px 25px 25px",
                      }}
                    >
                      <div className="text-white-color font-family-roboto line-35 text-start font-30 fonts-800 mobile-contactus-heading">
                        Not Convinced ?
                      </div>
                      <Link to="/why-yantr-ai">
                        <Button
                          className="py-12 px-40 font-16 fonts-500 text-white-color"
                          text="Why Yantr.ai"
                        />
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Platform;
